import { t } from 'i18next';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logout } from '../../../assets/svg/logout.svg';
import Content from '../../../components/mplat/Content';
import ContentRightSideSticky from '../../../components/mplat/ContentRightSideSticky';
import { useLazyGetAccountLoginQuery } from '../../../services/users_v1';
import Accounts from './Accounts';
import AccountsHeading from './AccountsHeading';
import AccountsList from './AccountsList';
import AccountsName from './AccountsName';


function AccountSelection() {
    const [fetchAccounts, { data: accounts }] = useLazyGetAccountLoginQuery();

    useEffect(() => { document.title = t('My accounts'); }, [t]);

    useEffect(() => {
        fetchAccounts();
    }, []);

    return (
        <Content>
            <ContentRightSideSticky>
                <Link to="/logout" title={t('Log out')}>
                    <Logout />
                </Link>
            </ContentRightSideSticky>
            <Accounts>
                <AccountsHeading />
                <AccountsName />
                <AccountsList list={accounts?.results || []} />
            </Accounts>
        </Content>
    )
}

export default AccountSelection;
